import { PropsWithChildren, SVGAttributes } from "react";

export type SvgIconProps = Omit<SVGAttributes<SVGSVGElement>, "width" | "height" | "xmlns" | "viewbox"> & {
  /**
   * Icon `size` can be a number to represent pixel units,
   * or a string to represent em or rem units.
   */
  size?: number | `${number}em` | `${number}rem`;
};

export const SvgIcon: React.FC<PropsWithChildren<SvgIconProps>> = ({
  children,
  onClick,
  viewBox,
  size = "1em",
  ...props
}) => {
  const className = [typeof onClick === "function" ? "cursor-pointer" : ""].join(" ");
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      {...props}
    >
      {children}
    </svg>
  );
};
